<template>
    <div>
        <PageTitle :title="$t('ayuda.contacto')" class="strech"/>

        <section v-if="!formBg" class="login-section">
            <div class="thumb-container absolute" :style='"background-image: url(" + footer.bg4_url + ")"'></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8 col-xl-5">
                        <div class="has-header d-flex">
                            <div class="form-content form-team-content w-100 white-content">
                                <ValidationObserver tag="form" ref="observer" @submit.prevent="addMessage">
                                    <div class="form-group">
                                        <FormInput :label="$t('ayuda.email')" type="email" name="email" id="email"
                                                   rules="required|email" v-model="data.email"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <FormInput :label="$t('ayuda.title')" type="text" name="titulo" id="titulo" rules="required"
                                                   v-model="data.subject"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="Email">{{ $t('ayuda.message') }}</label>
                                        <ValidationProvider name="message" rules="required" v-slot="{ errors }">
                                            <textarea v-model="data.message" :placeholder="$t('ayuda.message')"
                                                      class="form-control" :class="errors[0] ? 'is-invalid' : ''"
                                                      maxlength="500" minlength="8"
                                            ></textarea>
                                            <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="row justify-content-center">
                                        <vue-recaptcha @verify="onCaptchaVerified" :sitekey="sitekey"
                                                       :loadRecaptchaScript="true"
                                        />
                                    </div>
                                    <div class="row justify-content-md-between mt-3">
                                        <div class="col-12">
                                            <button :disabled="captcha" type="submit" class="button btn-block"
                                                    name="button"
                                            >{{ $t('ayuda.enviar')
                                            }}</button>
                                        </div>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Gracias :color="footer.bg4_url" v-else />
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import VueRecaptcha from 'vue-recaptcha';
    import Gracias from '@/components/frontend/ayuda/Gracias';
    import { config } from '@/config.js';
    export default {
        components: {
            PageTitle,
            VueRecaptcha,
            Gracias
        },
        data() {
            return {
                sitekey: process.env.VUE_APP_GOOGLE_SITE_KEY,
                captchaResponse: null,
                captcha: true,
                data: {
                    email: '',
                    subject: '',
                    message: '',
                },
                config: config,
                formBg: false,
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            onCaptchaVerified(response) {
                this.captchaResponse = response;
                this.captcha = false;
            },
            async addMessage() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.captcha = true;
                    this.data.filters = {
                        tid: this.configuracion.hash_teatro
                    };
                    this.$store.dispatch(this.config.getVuexAlias('front.ayuda'), this.data).then(() => {
                        this.$toast.success('Email Enviado correctamente');
                        this.captcha = false;
                        this.formBg = true;
                    }).catch(er => {
                        this.$toast.error('Ha ocurrido un error, inténtelo más tarde');
                        this.captcha = false;
                    })
                }
            },
        }
    };
</script>